import React from "react";
import styles from "./copyIconInput.module.scss";
import CopyIcon from "../copy/copyIcon";

type CopyIconInputProps = {
  value: string;
};

const CopyIconInput: React.FC<CopyIconInputProps> = React.memo((props) => {
  const { value } = props;
  return (
    <div className={styles.copyButton}>
      <div
        className={styles.copyButton__button}
        onClick={() => {
          navigator.clipboard.writeText(value || "");
        }}>
        <CopyIcon size={16} color="#1E1E20" />
      </div>
    </div>
  );
});

export default CopyIconInput;
